export default __webpack_public_path__ + "static/media/no-user-picture.ccbb6964.svg";